export default {
  PROFILE_URL: 'https://api.github.com/users/AndreLorenz',
  REPOS_URL: 'https://api.github.com/users/AndreLorenz/repos'
};


// WEBPACK FOOTER //
// ./services/service.constant.js